import {Address} from "~/api-client";
import { UploadImage } from "~/modules/common/services/util/types";

const UPPERCASE_LETTERS = '(?=.*[A-Z])';
const LOWERCASE_LETTERS = '(?=.*[a-z])';
const DIGITS = '(?=.*[0-9])';
const SPECIAL_CHARACTER = '(?=.*[^A-Za-z0-9])';

const PW_COMPLEXITY_REGEX = `${LOWERCASE_LETTERS}${UPPERCASE_LETTERS}${DIGITS}(?=.{MINLENGTH,})|${LOWERCASE_LETTERS}${UPPERCASE_LETTERS}${SPECIAL_CHARACTER}(?=.{MINLENGTH,})`;

export function ensurePasswordComplexity(password: string, minLength: number): boolean {
  const finalRegex = PW_COMPLEXITY_REGEX.replaceAll('MINLENGTH', minLength.toString());
  return new RegExp(finalRegex).test(password);
}

export function containsUppercaseLetters(value: string | undefined): boolean {
  return !!value && new RegExp(UPPERCASE_LETTERS).test(value);
}

export function containsLowercaseLetters(value: string | undefined): boolean {
  return !!value && new RegExp(LOWERCASE_LETTERS).test(value);
}

export function containsDigits(value: string | undefined): boolean {
  return !!value && new RegExp(DIGITS).test(value);
}

export function containsSpecialCharacters(value: string | undefined): boolean {
  return !!value && new RegExp(SPECIAL_CHARACTER).test(value);
}

export function lengthAtLeast(value: string | undefined, minLength: number): boolean {
  const regexToCheck = `(?=.{${minLength},})`;
  return !!value && new RegExp(regexToCheck).test(value);
}

export function isValidEmail(value: string): boolean {
  return new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(value);
}

export function isValidPhoneNumber(value: string): boolean {
  return new RegExp(/^[\+\]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{2,10}$/im).test(value);
}

export function isValidBic(value: string): boolean {
  return /^([A-Z]{6}[A-Z2-9][A-NP-Z1-2])(X{3}|[A-WY-Z0-9][A-Z0-9]{2})?$/.test(value.toUpperCase());
}

export function getValidImageWidth(useCase: string, extraImage:boolean) {
  switch (useCase) {
    case 'LOGO':
      return '600 - 3200 Pixel';
    case 'EDITORIAL':
      if (!extraImage) {
        return '600 - 2500 Pixel';
      } else {
        return '200 - 600 Pixel'
      }
  }
}

export function getValidImageHeight(useCase: string, extraImage:boolean) {
  switch (useCase) {
    case 'LOGO':
      return '200 - 1000 Pixel';
    case 'EDITORIAL':
      if (!extraImage) {
        return '600 - 2500 Pixel';
      } else {
        return '200 - 600 Pixel'
      }
  }
}

export function isValidImageWidth(width: number, useCase: string, extraImage:boolean) {
  switch (useCase) {
    case 'LOGO':
      return (width >= 600 && width <= 3200);
    case 'EDITORIAL':
      if (!extraImage){
        return (width >= 600 && width <= 2500);
      } else {
        return (width >= 200 && width <= 600);
      }
  }

  return true;
}

export function isValidImageHeight(height: number, useCase: string, extraImage:boolean) {
  switch (useCase) {
    case 'LOGO':
      return (height >= 200 && height <= 1000);
    case 'EDITORIAL':
      if (!extraImage){
        return (height >= 600 && height <= 2500);
      } else {
        return (height >= 200 && height <= 600);
      }
  }

  return true;
}

export function isValidAddress(address: Address) {
  return !!address.city && !!address.street && !!address.zipcode && ((!!address.firstName && !!address.lastName) || !!address.companyName);
}

export function isProductImageValid(fileUpload: UploadImage, isValidImageSize: boolean){

  const allowedImageTypes = ['image/png', 'image/jpg', 'image/jpeg'];

  if (!allowedImageTypes.includes(fileUpload.type)) {

    ElMessageBox.alert('Der Bilderupload unterstützt nur JPEG- und PNG-Dateien', 'Hinweis', {
      confirmButtonText: 'OK',
      type: 'warning'
    });

    throw new Error("Filetype not supported");

  }
  if (!isValidImageSize) {
    ElMessageBox.alert('Die maximale Dateigröße für den Bilder-Upload beträgt 2 MB. ', 'Hinweis', {
      confirmButtonText: 'OK',
      type: 'warning'
    });
    // this.$refs.productImageUpload.abort(file);
    throw new Error("Filetype not supported");

  }
  if (!isValidImageWidth(fileUpload.width, 'PRODUCT_IMG', false)) {
    ElMessageBox.alert('Die Breite des Bildes entspricht nicht den Vorgaben von ' + getValidImageWidth('PRODUCT_IMG', false), 'Hinweis', {
      confirmButtonText: 'OK',
      type: 'warning'
    });
    // processing.value = false;
    // this.$refs.productImageUpload.abort(file);
    throw new Error("Filetype not supported");

  }

  if (!isValidImageHeight(fileUpload.height, "PRODUCT_IMG", false)) {
    ElMessageBox.alert('Die Höhe des Bildes entspricht nicht den Vorgaben von ' + getValidImageHeight('PRODUCT_IMG', false), 'Hinweis', {
      confirmButtonText: 'OK',
      type: 'warning'
    });
    // processing.value = false;
    // this.$refs.productImageUpload.abort(file);
    throw new Error("Filetype not supported");

  }
  return true;
}
